class ExtendedSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector(".swiper");
    this.pagination = this.querySelector(".swiper-pagination");
    this.navNext = this.querySelector(".swiper-button-next");
    this.navPrev = this.querySelector(".swiper-button-prev");
    this.autoplaystate = this.swiper.dataset.autoplay;
    this.allowmove = this.swiper.dataset.allowmove || 'false';
    this.disableinteraction = this.swiper.dataset.disableinteraction || 'false';

    if (this.autoplaystate == "true") {
      this.autoplay = {
        delay: 3000,
      };
    } else {
      this.autoplay = false;
    }

    this.init();
  }

  init() {
    const swiperWrapper = this.querySelector(".swiper-wrapper");
    const speed = Number(swiperWrapper.getAttribute("data-speed"));
    const gap = Number(swiperWrapper.getAttribute("data-gap")) || 20;
    const mItem = Number(swiperWrapper.getAttribute("data-mobileitem")) || 2;
    const item = Number(swiperWrapper.getAttribute("data-item")) || 5;
    new Swiper(this.swiper, {
      speed: speed,
      autoplay: this.autoplay,
      pagination: {
        el: this.pagination,
        clickable: true,
        dynamicBullets: true,
      },

      // Navigation arrows
      navigation: {
        enabled: true,
        nextEl: this.navNext,
        prevEl: this.navPrev,
      },
      loop: true,
      slidesPerView: mItem,
      spaceBetween: gap,
      allowTouchMove: this.allowmove === "true" ? true : false,
      disableOnInteraction: this.disableinteraction === "true" ? true : false,
      breakpoints: {
        578: {
          slidesPerView: mItem,
        },
        968: {
          slidesPerView: mItem + 1,
        },
        1160: {
          slidesPerView: item - 1,
        },
        1478: {
          slidesPerView: item
        },
      },
    });
  }
}

customElements.define("extended-slider", ExtendedSlider);
